import { render } from "./BestMovies.vue?vue&type=template&id=38cb28fc&scoped=true"
import script from "./BestMovies.vue?vue&type=script&lang=js"
export * from "./BestMovies.vue?vue&type=script&lang=js"

import "./BestMovies.vue?vue&type=style&index=0&id=38cb28fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cb28fc"]])

export default __exports__